<template>
    <div class="tc-case-menu-item-select"
         :class="{'tc-case-menu-item-active': isActive}"
         :title="item.name" @click="$emit('selectPreset')">
        <img class="tc-item-select-image"
             draggable="false"
             :src="getImage(item.image)">
        <div class="tc-item-select-tip-anchor">
            <div class="tc-item-select-tip">
                <SVGMagicApply/>
            </div>
        </div>
    </div>
</template>

<script>

import SVGMagicApply from '@/UI/SVG/SVGMagicApply.vue';
import { getImage } from '@/libs/getImage';

export default {
    name: 'CaseMenuItemSelect',
    components: {
        SVGMagicApply,
    },
    props: [
        'isActive',
        'item',
    ],
    emits: [
        'selectPreset',
    ],
    methods: {
        getImage,
    },
};
</script>

<style scoped lang="scss">
.tc-case-menu-item-select {
    display: flex;
    flex-direction: column;
    height: max-content;
    justify-content: flex-start;
    align-items: center;
    color: #333333;
    position: relative;
    user-select: none;
    transition: 0.3s ease all;
    cursor: pointer;
    border: 1px solid transparent;
    padding: 2px;
}

.tc-case-menu-item-select:hover {
    color: #00458D;
    border-color: #00458D;
}

.tc-case-menu-item-active {
    color: #00458D;
    border-color: #00458D;
}

.tc-item-select-image {
    width: 120px;
    height: 154px;
    object-fit: cover;

    background-color: #f2f2f2;
}

.tc-item-select-tip-anchor {
    position: absolute;
    display: flex;
    align-items: flex-end;
    height: 0;
}


.tc-item-select-tip {
    position: relative;
    top: 154px;
    left: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;

}
</style>
